module.exports = __webpack_public_path__ + "img/atalho-2.bcc08064.png";